import { useQuery } from "@tanstack/react-query";
import { useContext } from "react";
import {
	GetJobHistoryApiResponse,
	JobEvent
} from "../../DataModels/DataModels";
import { API_HTTP, resumeAnalyzerApiEndpoints } from "./endpoints";
import { AuthContext } from "../../context/AuthProvider";
import { User } from "firebase/auth";
import ApiInterface from "./api-interface";

const ONE_HOUR_DURATION_IN_MS = 60 * 60 * 1000;

export interface UseJobHistoryResult {
	events: JobEvent[];
	isLoading: boolean;
	isError: boolean;
}

export function useJobHistory(
	jobId: string,
	enabled: boolean = true
): UseJobHistoryResult {
	const authContext = useContext(AuthContext);
	const user = authContext?.user as User | undefined;
	const userId = user?.uid;

	const { data, isLoading, isError } = useQuery<GetJobHistoryApiResponse>({
		queryKey: ["history", jobId],
		queryFn: async () => {
			const apiClient = new ApiInterface(API_HTTP.resumeAnalyzer, user);
			return apiClient.get(resumeAnalyzerApiEndpoints.jobHistory, {
				jobId
			});
		},
		staleTime: ONE_HOUR_DURATION_IN_MS,
		enabled: !!userId && enabled
	});

	return {
		events: data?.events ?? [],
		isLoading,
		isError
	};
}
